import { ReviewSimple } from '../../services/EmployeeService'
import { TableCellBody, TableCellBodyParams } from './AppTable/TableCellBody'

export const EmployeeSimpleReviewsTableCellBody = (params?: TableCellBodyParams<ReviewSimple>) =>
  TableCellBody<ReviewSimple>(params)
